import { dashboardEnglish } from './dashboard.ts';
// English catalog. Namespaces not listed here fall back to zh-CN (see i18n/index.ts).
// Currently translated: common, nav, layout, routeState, dingtalk, settings.
export default {
  dashboard: dashboardEnglish,
  common: {
    loading: 'Loading…',
    retry: 'Retry',
    cancel: 'Cancel',
    close: 'Close',
    form: 'Form',
    rawJson: 'Raw JSON',
    detailTabs: 'Detail views',
    copy: 'Copy',
    copied: 'Copied',
    copyFailed: 'Copy failed',
    yes: 'Yes',
    no: 'No',
    create: 'Create',
    refresh: 'Refresh',
    actions: 'Actions',
    empty: 'No records in the current scope.',
    previous: 'Previous',
    next: 'Next',
    pagination: '{page} / {pages} · {total} total',
    paginationLabel: 'Table pagination',
    none: 'None',
    selectAll: 'Select all',
    networkError: 'Cannot reach the service. Check your network and try again.',
    requestFailed: 'Request failed. Try again later.',
    diagnostics: 'Diagnostics',
    code: 'Code',
    traceId: 'Trace ID',
    rawMessage: 'Raw message',
    unsavedCloseConfirm: 'This form has unsaved changes. Close anyway?',
    downloadExpired: 'Download failed or expired',
    fields: {
      item: 'Item {index}',
      id: 'ID',
      value: 'Value',
      resource_id: 'Resource ID',
      resource_type: 'Resource type',
      record_version: 'Record version',
      name: 'Name',
      display_name: 'Display name',
      title: 'Title',
      description: 'Description',
      state: 'State',
      status: 'Status',
      result: 'Result',
      owner: 'Owner',
      owner_id: 'Owner ID',
      assignee: 'Assignee',
      business_line_id: 'Business line ID',
      org_scope: 'Organization scope',
      created_at: 'Created at',
      updated_at: 'Updated at',
      created_by: 'Created by',
      updated_by: 'Updated by',
      metric_id: 'Metric ID',
      current_version_id: 'Current version ID',
      metric_version_id: 'Metric version ID',
      version: 'Version',
      level: 'Level',
      gap: 'Data gap',
      unit: 'Unit',
      target_value: 'Target value',
      period_start: 'Start date',
      period_end: 'End date',
      user_id: 'User ID',
      username: 'Username',
      email: 'Email',
      role_id: 'Role ID',
      roles: 'Roles',
      permissions: 'Permissions',
      action: 'Action',
      actor: 'Actor',
      severity: 'Severity',
      due_at: 'Due at',
      evidence: 'Evidence',
      source: 'Source',
      source_name: 'Source name',
      type: 'Type',
      filename: 'Filename',
      shape: 'Dataset shape',
      classification: 'Classification',
      revision: 'Revision',
      parent_id: 'Parent ID',
    },
  },
  objectCombobox: {
    select: 'Select an option',
    selectUser: 'Select a Compass user',
    selectBusinessLine: 'Select a business line',
    selectOrganizations: 'Select organizations',
    search: 'Search by name or ID',
    empty: 'No matching options',
    unlinked: 'Unlinked',
    selectedCount: '{count} selected',
    remove: 'Remove {item}',
    moveUp: 'Move {item} up',
    moveDown: 'Move {item} down',
    create: 'Create a new item',
  },
  directory: {
    createBusinessLine: 'Create business line',
    createOrganization: 'Create organization',
    businessLineId: 'Business line ID',
    organizationId: 'Organization ID',
    parentOrganization: 'Parent organization',
    noParentOrganization: 'No parent organization',
    creating: 'Creating…',
  },
  nav: {
    overview: 'Overview',
    metrics: 'Metric catalog',
    'metric-import': 'Metric import',
    query: 'Metric query',
    governance: 'Review & publish',
    metadata: 'Metadata center',
    knowledge: 'Knowledge base',
    targets: 'Targets',
    tasks: 'Tasks',
    dashboards: 'Dashboard designer',
    dashboardDatasets: 'Dashboard datasets',
    sources: 'Data sources',
    'dw-builder': 'DW builder',
    'business-objects': 'Business objects',
    exports: 'Exports',
    users: 'Users & identities',
    dingtalk: 'DingTalk sync',
    platformSettings: 'Platform settings',
    roles: 'Roles & permissions',
    audit: 'Audit & access',
  },
  layout: {
    brand: '福瑞Compass',
    brandSubtitle: 'Operations Data Platform',
    eyebrow: 'COMPASS / WORKSPACE',
    connected: 'Connected',
    disconnected: 'Disconnected',
    mainNav: 'Main navigation',
    themeToggle: 'Switch theme',
    themeMenu: 'Theme',
    themeDark: 'Dark',
    themeLight: 'Light',
    themeBlue: 'Blue',
    logout: 'Log out',
    expandSidebar: 'Expand sidebar',
    collapseSidebar: 'Collapse sidebar',
    logoutConfirmTitle: 'Log out?',
    logoutConfirmBody: 'You will need to authenticate again to continue.',
    confirmLogout: 'Log out',
    language: 'Language',
    langZh: '简体中文',
    langEn: 'English',
    accountMenu: 'Account menu',
    appVersion: 'System version',
  },
  routeState: {
    forbiddenTitle: 'Access denied',
    featureDisabledTitle: 'Business objects are not enabled',
    unavailableTitle: 'Service unavailable',
    notFoundTitle: 'Page not found',
    forbiddenMessage: 'Your account has no access to this page. Choose an available feature from the navigation.',
    featureDisabledMessage: 'This feature is not enabled in the current environment. Contact an administrator to confirm the feature flag.',
    unavailableMessage: 'Unable to verify the session or reach the service. Try again later.',
    notFoundMessage: 'Page not found. Choose a feature from the navigation.',
    backHome: 'Back to home',
    login: 'Log in',
  },
  dingtalk: {
    syncQueued: 'Sync queued. Refresh to see the latest directory once it completes.',
    mappingDenied: 'Adjusting department mappings requires organization policy permission; this account has read-only access.',
    enterprise: 'Enterprise',
    runFullSync: 'Run full sync',
    working: 'Working…',
    refresh: 'Refresh',
    unmappedUsers: 'Unmapped DingTalk users',
    colUser: 'User',
    colEmail: 'Email',
    colTitle: 'Title',
    colDepartment: 'Department',
    colCompassUser: 'Compass user',
    selectUser: 'Select user',
    bind: 'Bind',
    noUnmapped: 'No unmapped users',
    deptMappings: 'Department mappings',
    colParent: 'Parent',
    colCompassOrg: 'Compass organization',
    unmapped: 'Unmapped',
    noDepartments: 'No departments synced',
  },
  settings: {
    localTestOnly: 'Local validation only (connectivity needs manual verification)',
    title: 'Platform settings',
    subtitle: 'Manage platform connections and runtime parameters in one place',
    navAria: 'Settings namespaces',
    editable: 'Editable',
    governed: 'Governed',
    deployed: 'Deployed',
    loading: 'Loading settings…',
    sourceOverride: 'Administrator override',
    sourceEnvironment: 'Deployment environment',
    sourceAuthoritative: 'Authoritative configuration',
    closeHistory: 'Close history',
    showHistory: 'History',
    resetToInherit: 'Reset to inherited',
    refreshSettings: 'Refresh settings',
    sourceLabel: 'Source',
    recordVersion: 'Record version',
    statusLabel: 'Status',
    healthReady: 'Ready',
    healthRestart: 'Restart required',
    healthKeyUnavailable: 'Key unavailable',
    testTarget: 'Test target',
    runTest: 'Test saved settings',
    manualTestHint: 'This setting has no automated remote check; complete external validation using the runbook.',
    managedGoverned: 'This configuration is managed by a published governance policy.',
    managedDeployed: 'This configuration is managed by deployment operations.',
    openManagement: 'Open management entry',
    historyTitle: 'History',
    colRevision: 'Revision',
    colMode: 'Mode',
    colChangedFields: 'Changed fields',
    colTime: 'Time',
    colActor: 'Actor',
    colAction: 'Action',
    rollback: 'Restore',
    noHistory: 'No history yet',
    namespaceUnavailable: 'Settings namespace unavailable.',
    save: 'Save',
    enableConfig: 'Enable configuration',
    enabled: 'Enabled',
    disabled: 'Disabled',
    jsonInvalid: 'Invalid JSON',
    noticeSaved: 'Saved',
    noticeSavedRestart: 'Saved; restart required',
    noticeRestored: 'Inherited configuration restored',
    noticeRollbackCreated: 'Restore revision created',
    errors: {
      UNKNOWN_REQUEST: 'The settings request could not be completed. Check the input and current revision.',
      UNKNOWN_SERVICE: 'The settings service is temporarily unavailable. Try again or contact operations.',
      SETTINGS_VALIDATION: 'The settings request is invalid.',
      SETTINGS_REQUEST_TOO_LARGE: 'The settings request is too large.',
      SETTINGS_FORBIDDEN: 'Tenant-wide platform settings administrator access is required.',
      SETTINGS_NAMESPACE: 'The settings namespace is unavailable.',
      SETTINGS_ROUTE: 'The settings operation is unavailable.',
      SETTINGS_NOT_OPERATIONAL: 'These settings are managed by their existing authority.',
      SETTINGS_STORAGE: 'Settings storage is unavailable. Retry or contact operations.',
      SETTINGS_KEY_UNAVAILABLE: 'Settings encryption is unavailable. Check the platform encryption key configuration.',
      SETTINGS_KEY_CONFIG: 'The platform settings encryption keyring is invalid.',
      SETTINGS_DECRYPT_FAILED: 'Saved settings credentials cannot be decrypted. Check encryption key rotation and retained keys.',
      SETTINGS_DIGEST_KEY_UNAVAILABLE: 'The request signing key is unavailable. Refresh and retry or contact operations.',
      SETTINGS_SCHEMA: 'The saved settings revision uses an unsupported schema.',
      SETTINGS_INVALID: 'The saved settings revision is invalid.',
      SETTINGS_CONFLICT: 'Settings were modified by another administrator. Your form and restore content are kept until you refresh.',
      SETTINGS_IDEMPOTENCY_CONFLICT: 'This request key was already used for different settings content. Refresh and retry with a new request.',
      SETTINGS_BASELINE_CONFLICT: 'Deployment environment settings changed. Refresh before importing, resetting, or restoring.',
      SETTINGS_REVISION: 'The requested settings revision is unavailable or no longer current.',
      SETTINGS_REVISION_CONFLICT: 'Saved settings changed. Refresh before testing or validating.',
      SETTINGS_TEST_UNAVAILABLE: 'Saved settings testing is unavailable.',
      SETTINGS_TEST_TARGET: 'Select a valid enabled target from the saved settings.',
      SETTINGS_TEST_RUNNING: 'A saved settings test is already running for this target.',
      SETTINGS_TEST_RATE_LIMIT: 'Too many saved settings tests. Wait and retry.',
      SETTINGS_TEST_OWNER: 'The saved settings test session expired. Run the test again.',
      SETTINGS_TEST_TIMEOUT: 'The saved settings test timed out.',
      SETTINGS_TEST_NETWORK: 'The saved settings test could not reach the target.',
      SETTINGS_TEST_TLS: 'The saved settings test failed TLS validation.',
      SETTINGS_TEST_BUDGET: 'The saved settings test exceeded its execution policy or call budget.',
      SETTINGS_TEST_POLICY: 'The saved settings test was blocked by the connection policy.',
      SETTINGS_TEST_RESPONSE: 'The saved settings test returned an invalid response.',
      SETTINGS_TEST_UNAUTHORIZED: 'The saved settings test credentials were rejected.',
      SETTINGS_TEST_PERMISSION: 'The saved settings test credentials lack required permissions.',
      SETTINGS_STREAM_UNAVAILABLE: 'DingTalk Stream validation is unavailable.',
      SETTINGS_STREAM_TARGET: 'Select an enabled saved DingTalk enterprise.',
      SETTINGS_STREAM_RATE_LIMIT: 'Too many active DingTalk Stream validations. Stop one and retry.',
      DINGTALK_STREAM_CONNECT_TIMEOUT: 'DingTalk Stream connection timed out.',
      DINGTALK_STREAM_CONNECT_FAILED: 'Could not connect to DingTalk Stream. Check the saved enterprise configuration.',
      DINGTALK_STREAM_DISCONNECTED: 'DingTalk Stream disconnected unexpectedly.',
      DINGTALK_STREAM_CONFIG_CHECK_FAILED: 'DingTalk did not confirm the Stream channel configuration in time.',
      DINGTALK_STREAM_SHUTDOWN: 'DingTalk Stream validation stopped because the service is shutting down.',
      DINGTALK_STREAM_FAILED: 'DingTalk Stream channel validation failed.',
      NETWORK_ERROR: 'Cannot reach the service. Check your network and try again.',
      STREAM_PROTOCOL_ERROR: 'The service returned an invalid settings validation stream.',
    },
    validation: {
      rejected: 'Settings were not saved: {details}',
      rootField: 'Settings',
      required: 'required',
      duplicate: 'must be unique',
      invalid: 'invalid',
      invalid_type: 'has the wrong type',
      unsafe_key: 'contains an unsafe field',
      unknown_field: 'is not an allowed field',
      invalid_https_url: 'must be a valid HTTPS URL',
      ldaps_required: 'must be a valid LDAPS URL',
      invalid_certificate: 'contains an invalid certificate',
      invalid_endpoint: 'has an invalid endpoint',
      out_of_range: 'is outside the allowed range',
      invalid_enum: 'is not an allowed option',
      separate_role_required: 'reader and writer roles must be different',
      unsupported: 'is not supported in this environment',
      invalid_identifier: 'has an invalid identifier',
      invalid_value: 'has an invalid value',
    },
    confirmDisableLastProvider: 'Disabling the identity provider may affect sign-in. Continue?',
    confirmRefreshDiscard: 'Refreshing discards the current form, including unsaved secret replacements. Refresh anyway?',
    confirmReset: 'Resetting restores the inherited deployment configuration. Continue?',
    confirmRollbackInherit: 'This revision represents inheritance and restores the current environment baseline. Continue?',
    confirmRollbackVersion: 'A new settings revision will be created from this historical revision. Continue?',
    confirmLeaveDirty: 'The form has unsaved changes. Leaving clears secret replacements. Continue?',
    test: {
      title: 'Test results',
      historical: 'Historical results',
      passed: 'All checks passed',
      partial: 'Partial checks completed',
      manual: 'Manual check required',
      failed: 'Check failed',
      versionPrefix: 'Version',
      envConfig: 'Environment configuration',
      defaultTarget: 'Default target',
      checkFallback: 'Check',
      statusFallback: 'Unknown status',
      categories: {
        timeout: 'Timeout',
        network: 'Network error',
        tls: 'TLS error',
        unauthorized: 'Unauthorized',
        permission: 'Insufficient permission',
        invalid_response: 'Invalid response',
        policy_denied: 'Denied by connection policy',
        disabled: 'Disabled',
        unsupported: 'Unsupported',
      },
      statuses: { passed: 'Passed', failed: 'Failed', skipped: 'Skipped', manual: 'Manual check required' },
    },
    secret: {
      configured: 'Configured',
      notConfigured: 'Not configured',
      keepPlaceholder: 'Leave empty to keep the current value',
      enterNew: 'Enter a new value',
      clear: 'Clear',
    },
    activation: {
      runtime: 'Runtime status',
      desiredVersion: 'Target revision',
      currentProcess: 'Current process',
      envConfig: 'Environment configuration',
      scopeResponding: 'Reflects the responding process only',
      scopeUnknown: 'Process scope unknown',
    },
    dingtalk: {
      newCorp: 'New enterprise',
      corpId: 'CorpID',
      corpName: 'Enterprise name',
      appKey: 'Client ID',
      agentId: 'AgentId',
      appSecret: 'Client Secret',
      callbackToken: 'Token',
      aesKey: 'EncodingAESKey',
      fieldLabel: 'DingTalk · {label}',
      sourceLabels: {
        corp_id: 'CorpID',
        name: 'Enterprise name',
        app_key: 'AppKey',
        agent_id: 'AgentId',
        app_secret: 'AppSecret',
        callback_token: 'Callback Token',
        encoding_aes_key: 'EncodingAESKey',
      },
      removeCorp: 'Remove enterprise',
      addCorp: 'Add enterprise',
      confirmRemoveLast: 'Removing the last enterprise disables DingTalk sign-in. Continue?',
      stream: {
        title: 'Stream channel validation',
        subtitle: 'Open a temporary online channel for DingTalk console validation.',
        stepStart: 'Keep this panel open, select a saved enterprise, and click “Start connection”.',
        stepValidate: 'Once the status is “Online”, click “Verify connection channel” in the DingTalk Developer Console.',
        stepStop: 'Stop when finished or let the connection expire after 2 minutes. This is temporary validation only; production events are not processed or acknowledged as consumed.',
        selected: 'Enterprise to validate',
        start: 'Start Stream connection',
        stop: 'Stop Stream connection',
        expiresAt: 'Expires at',
        saveFirst: 'Save the current settings changes before starting a connection.',
        failed: 'Stream channel validation failed',
        status: { idle: 'Not started', connecting: 'Connecting', online: 'Online', stopped: 'Stopped', expired: 'Expired', error: 'Connection failed' },
      },
    },
  },
};
